import axios from 'axios';
import { IDeviation } from '@/shared/model/deviation.model';
import { ISpecialLimit } from '@/shared/model/special-limit.model';

const baseApiUrl = 'api/special-limits';

export default class SpecialLimitsService {
  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(specialLimit: ISpecialLimit): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(baseApiUrl, specialLimit)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
